/**
 * ============================================================================
 * USER / TENANT SERVICE: Support, Alerts & Logs (Sheets 30, 32, 33)
 * ============================================================================
 * Purpose:
 *   Handles customer helpdesk tickets (`tbl_support_tickets`), in-app alerts
 *   (`tbl_notifications`), and execution error logs (`tbl_account_operation_log`).
 *
 * Database Scope:
 *   Tenant Database (`digi_user_<id>`)
 * ============================================================================
 */

import api from "../../core/services/api";
import { createCrudService } from "../../core/services/crudServiceFactory";

const ticketBaseService = createCrudService("tenant/tickets");
const notificationService = createCrudService("tenant/notifications");
const opLogService = createCrudService("tenant/oplogs");

const ticketService = {
  ...ticketBaseService,
  notifications: notificationService,
  opLogs: opLogService,

  /**
   * Appends a message/reply to an existing support ticket thread.
   *
   * @param {string} ticketId
   * @param {Object} message - { str_subject, str_description, str_created_by }
   * @returns {Promise<Object>} Updated ticket
   */
  addMessage: (ticketId, message) => {
    return api.post(`/tenant/tickets/${ticketId}/messages`, message);
  },

  /**
   * Marks a notification as read.
   *
   * @param {number|string} notificationId
   * @returns {Promise<Object>}
   */
  markNotificationRead: (notificationId) => {
    return api.put(`/tenant/notifications/${notificationId}/read`);
  },
};

export default ticketService;
